var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.style,attrs:{"id":_vm.id},on:{"click":_vm.onClick}},[(!_vm.loading)?_c('div',{key:"value"},[_vm._v(_vm._s(_vm.value))]):_c('div',{key:"loading",staticClass:"spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }